import { Send } from '@mui/icons-material';

export const WAYS_OF_CONTACT_MAP = {
  ATTEND: `Endereço`,
  SEND_RESUME: `Enviar currículo`,
  SEND_EMAIL: `E-mail`,
  WEBSITE: `Site`,
  PHONE: `Telefone`,
  WHATSAPP: `WhatsApp`,
};
